import { ReactElement } from 'react';
import { Message } from '@messageformat/react';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import { space } from '@op/opds.tokens';
import { IconInformation } from '@op/opds.opux-icons/indicator';
import { Tile } from '@op/opds.opux';
import { msciGraphOptions } from '../utils';
import data from './data';

const MSCIGraph = (): ReactElement => {
  const options = msciGraphOptions(data, 2592000000);
  return (
    <div className="investoracademy-graph-wrapper">
      <Tile>
        <figure>
          <figcaption className="investoracademy-general-graph-title">
            <Message id="course2.part3.msci_graph.title" />
          </figcaption>
        </figure>
        <div
          className="investoracademy-general-graph-container"
          role="img"
          aria-labelledby="msci_graph"
        >
          <HighchartsReact highcharts={Highcharts} options={options} />
        </div>
        <div style={{ display: 'none' }} id="msci_graph">
          <Message id="course2.part3.msci_graph.accessibility_graph_text" />
        </div>
      </Tile>
      <p
        className="opds-styles-v1-text-label-small"
        style={{ display: 'flex', paddingBottom: space.default }}
      >
        <IconInformation />
        <Message id="course2.part3.msci_graph.sources" />
      </p>
    </div>
  );
};

export default MSCIGraph;
